import { MensajeDTO } from 'src/app/global/interfaces/general-response';

export abstract class FirmaServiceVM {
  public abstract validStatusFirm(estado: string): Promise<MensajeDTO>;
}
